exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".masked-image[data-v-e79bfb16] {\n  background-color: #212121;\n  -webkit-mask-position: center;\n          mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n          mask-repeat: no-repeat;\n  -webkit-mask-size: contain;\n          mask-size: contain;\n  height: 2rem;\n  width: 2rem;\n  display: inline-block;\n}", ""]);

// exports
